var DARK = 'dark';
var LIGHT = 'light';
var DISPLAY_MODES = [DARK, LIGHT];
export { DARK, LIGHT, DISPLAY_MODES };